import React, { useState } from "react";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogTrigger, DialogDescription,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { errMsg } from "@/lib/api";

export default function ActionDialog({
  trigger, title, description, confirmLabel = "Confirm", onConfirm, requireNotes = false,
  destructive = false, testid = "action-dialog",
}) {
  const [open, setOpen] = useState(false);
  const [notes, setNotes] = useState("");
  const [loading, setLoading] = useState(false);

  const confirm = async () => {
    if (requireNotes && !notes.trim()) { toast.error("Please add a note."); return; }
    setLoading(true);
    try {
      await onConfirm(notes);
      setOpen(false);
      setNotes("");
    } catch (e) {
      toast.error(errMsg(e));
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>{trigger}</DialogTrigger>
      <DialogContent data-testid={testid}>
        <DialogHeader>
          <DialogTitle className="font-heading text-ff-blue">{title}</DialogTitle>
          {description && <DialogDescription>{description}</DialogDescription>}
        </DialogHeader>
        <div>
          <Label htmlFor="dlg-notes">Notes {requireNotes && <span className="text-ff-red">*</span>}</Label>
          <Textarea id="dlg-notes" data-testid="action-dialog-notes" rows={4} value={notes}
            onChange={(e) => setNotes(e.target.value)} className="mt-1.5" placeholder="Add a documented reason…" />
        </div>
        <DialogFooter>
          <Button variant="ghost" onClick={() => setOpen(false)}>Cancel</Button>
          <Button onClick={confirm} disabled={loading} data-testid="action-dialog-confirm"
            className={destructive ? "bg-ff-red text-white hover:bg-ff-red/90" : "bg-ff-blue text-white hover:bg-ff-blue/90"}>
            {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : confirmLabel}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
